/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createValidationProblemDetailsFromDiscriminatorValue, serializeAllotmentApproveRequest, type AllotmentApproveRequest, type ValidationProblemDetails } from '../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /Allotment/ApproveBatch
 */
export interface ApproveBatchRequestBuilder extends BaseRequestBuilder<ApproveBatchRequestBuilder> {
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @throws {ValidationProblemDetails} error when the service returns a 400 status code
     */
     post(body: AllotmentApproveRequest[], requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<void>;
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: AllotmentApproveRequest[], requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const ApproveBatchRequestBuilderUriTemplate = "{+baseurl}/Allotment/ApproveBatch";
/**
 * Metadata for all the requests in the request builder.
 */
export const ApproveBatchRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: ApproveBatchRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createValidationProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendNoResponseContent",
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeAllotmentApproveRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
